<template>
    <div class="stepsdemo-content">
        <Card>
           <template v-slot:title>
                {{$t('Datos de la Propiedad')}}
            </template>
            <template v-slot:subtitle>
                {{$t('solicitada')}}
            </template>
            <template v-slot:content>
                <div class="p-fluid p-formgrid p-grid">
					<div class="p-field p-col-12 p-md-12">
						<label>{{$t('Dirección')}}</label>
						<Textarea v-model="propiedad.direccion" rows="2"/>
                        <small v-show="validationErrors.direccion && submitted" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-12 p-md-3">
						<label>{{$t('Localidad')}}</label>
						<div v-if="i18n.locale() == 'es'">
							{{formData.datos.localidad.nombre}}
						</div>
						<div v-if="i18n.locale() == 'en'">
							{{formData.datos.localidad.name}}
						</div>
					</div>
					<div class="p-field p-col-12 p-md-9">
						<label>{{$t('Comentario')}}</label>
						<Textarea v-model="propiedad.comentario" rows="2"/>
                        <small v-show="validationErrors.comentario && submitted" class="p-error">{{$t('required')}}</small>
					</div>
					<div class="p-field p-col-12 p-md-12">
						<label>{{$t('Beneficiario')}}</label>
						<Textarea v-model="propiedad.beneficiario" rows="1"/>
					</div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="p-grid p-nogutter p-justify-between">
                    <Button :label="$t('Anterior')" @click="prevPage()" icon="pi pi-angle-left" />
                    <Button :label="$t('Siguiente')" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import API from "@/service/ApiConsulta";
import { useI18nPlugin } from '@unify/vuex-i18n';
import Token from "uuid-token-generator";
import url from "@/service/_URL";

export default {
    props: {
        formData: Object
    },
    data () {
        return {			
            submitted: false,
            validationErrors: {},
			tipos: null,
			propiedad: {
				evaluacion: null,
				titulo: null,
				direccion: null,
				localidad: null,
				comentario: null,
				beneficiario: null,
			},
			localidades: [],
            size: '40vw',
			img1: null,
			img2: null,
        }
    },
	created() {
        if (this.$store.state.mobile){this.size = '80vw';}
		this.i18n = useI18nPlugin();
        this.url = url;
        const Consulta = new API('Cotizacions');
		Consulta.Ini('Aviation').then(result => {
			if (result.consult.localidades){
				this.localidades = result.consult.localidades;
			}
		}); 
		const tokgen = new Token(256);
		this.img1 = tokgen.generate();
		this.img2 = tokgen.generate();
	},
    methods: {
        Ver(document){
            window.open(url.upload+document+'.pdf', '_blank');
		},
        nextPage() {
            this.submitted = true;
            if (this.validateForm() ) {
				this.propiedad.localidad = this.formData.datos.localidad;
                this.$emit('next-page', {formData: {propiedad: this.propiedad}, pageIndex: 1});
            }
        },
        prevPage() {
            this.$emit('prev-page', {pageIndex: 1});
        },
		myUploader(caso,img) {
			this.$store.commit('Loading');
			const Consulta = new API('Cotizacions');
			Consulta.Procesar('Aviation',{
				caso: 	'RevPDF',
				foto: img,
			}).then(response => {
				if(response.result){
					if(caso == 1){this.propiedad.evaluacion = img;}
					if(caso == 2){this.propiedad.titulo = img;}
				} else {
					this.$toast.add({
						severity:'warn', 
						summary: this.$t('Advertencia'), 
						detail: this.$t('Error en Foto'), 
						life: 3000
					});
				}
                const tokgen = new Token(256);
                this.img = tokgen.generate();
				this.$store.commit('Loading');
			});
		},
        validateForm() {
            if (this.propiedad.direccion==null)
               this.validationErrors['direccion'] = true;
            else
               delete this.validationErrors['direccion'];
            return !Object.keys(this.validationErrors).length;
        }
    }
}
</script>